// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"75be6350","453":"18b8740d","455":"9ab344c7","977":"59aa38bb"}[chunkId] + ".chunk.js";
};